module.exports = __webpack_public_path__ + "static/media/espaceD.03f1a676.svg";